import { ComponentPropsWithoutRef, FC } from 'react';

export const HeightMeasureInputMarkerIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => (
  <svg width="158" height="44" viewBox="0 0 158 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.04167 22C1.04167 33.7821 10.5929 43.3333 22.375 43.3333C34.1571 43.3333 43.7083 33.7821 43.7083 22C43.7083 10.2179 34.1571 0.666666 22.375 0.666666C10.5929 0.666666 1.04167 10.2179 1.04167 22ZM157.375 18H22.375V26H157.375V18Z"
      fill="#1EEB78"
    />
  </svg>
);
